<ion-card fxLayout="column" fxLayoutAlign="center center" class="myModal" id="msgModal">
	<ion-card-header fxLayout="row">
		<ion-card-title>
			<fa-icon
				[icon]="msModalData[0]?.icon"
				class="fa-2x"
				[ngStyle]="{ color: msModalData[0]?.iconColor }"
				style="margin-right: 15px"
			></fa-icon>
			{{ msModalData[0]?.title }}
		</ion-card-title>
	</ion-card-header>
	<ion-card-content fxLayout="row" fxLayoutAlign="center center">
		<hr />
		<div class="item item-text-wrap">
			{{ msModalData[0]?.message }}
		</div>
		<div style="margin-top: 20px">
			<ion-button expand="full" (click)="okay($event)">{{ msModalData[0]?.buttonText }}</ion-button>
		</div>
	</ion-card-content>
</ion-card>
